module.exports = __webpack_public_path__ + "static/rozpuszczalne_doypack-2cb13ec34a4ea4a1c5ed895039220a26.png";